<template>
  <div class="widget">
    <a href="#" @click="showChatChannels">
      <i class="fas fa-comments"></i>
      <span class="badge-unread custom-unread">{{ unreadCount }}</span>
    </a>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  name: 'chat-button',
  computed: {
    ...mapGetters('chat', ['unreadCount'])
  },
  methods: {
    showChatChannels() {
      this.$emit('showChatChannels')
    }
  }
}
</script>
<style lang="scss" scoped>
.widget {
  margin: 0;
  padding: 0;
  font-size: 100%;
  line-height: 1;
  width: auto;
  height: auto;
  box-sizing: initial;
  z-index: 99991;
  position: absolute;
  right: 10px;
  bottom: 10px;
  width: 60px;
  height: 60px;
  cursor: pointer;
  text-align: center;
  border-radius: 50%;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  -ms-border-radius: 50%;
  -o-border-radius: 50%;
  -webkit-box-shadow: 0 1px 6px rgba(0, 0, 0, 0.06), 0 2px 32px rgba(0, 0, 0, 0.16);
  -moz-box-shadow: 0 1px 6px rgba(0, 0, 0, 0.06), 0 2px 32px rgba(0, 0, 0, 0.16);
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.06), 0 2px 32px rgba(0, 0, 0, 0.16);
  background-color: #19274c;

  .notification {
    margin: 0;
    padding: 0;
    font-size: 100%;
    line-height: 1;
    width: auto;
    height: auto;
    box-sizing: initial;
    display: none;
    position: absolute;
    top: 0;
    right: 0;
    width: 20px;
    height: 20px;
    background-color: red;
    color: #ffffff;
    font-weight: 700;
    font-size: 12px;
    line-height: 20px;
    text-align: center;
    border-radius: 50%;
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    -ms-border-radius: 50%;
    -o-border-radius: 50%;
    -webkit-box-shadow: 0 1px 5px rgba(0, 0, 0, 0.28);
    -moz-box-shadow: 0 1px 5px rgba(0, 0, 0, 0.28);
    box-shadow: 0 1px 5px rgba(0, 0, 0, 0.28);
  }
  i {
    color: #ffffff;
    font-size: 1.9em;
    top: 15px;
    position: relative;
  }
}
.widget:hover {
  background-color: #293862;
  -webkit-box-shadow: 0 1px 9px rgba(0, 0, 0, 0.28), 0 2px 32px rgba(0, 0, 0, 0.16);
  -moz-box-shadow: 0 1px 9px rgba(0, 0, 0, 0.28), 0 2px 32px rgba(0, 0, 0, 0.16);
  box-shadow: 0 1px 9px rgba(0, 0, 0, 0.28), 0 2px 32px rgba(0, 0, 0, 0.16);
}
.custom-unread {
  position: absolute;
  right: 0;
  top: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/chat/chat-button.vue